// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".color--primary[data-v-f3c7a1a4]{color:#c81919}.coin--transfer-available[data-v-f3c7a1a4]{font-family:Poppins-SemiBold,sans-serif;font-size:1.25rem}", ""]);
// Exports
module.exports = exports;
